import { getUsuarioCompact } from "../../../config/auth"
import { generateUUIDV7, normalizedField, randomNumber } from "../../../shared/utils"
import { getCompanyById, updateCompanyById, updateCompanyChargeById } from "../../../store/collections/companyWorker"
import { addNewNote, getNewNoteByIdentifier } from "../../../store/collections/newNotesWorker"
import { getParameterByParkId } from "../../../store/collections/parameterWorker"
import { addQueue } from "../../../store/collections/queueWorker"

export const registerCompanyChargePayment = async ({ charge, cashier, paymentMethod, paymentDate, generateNote }) => {
    if (!charge.logs) {
        charge.logs = []
    }
    if (charge.status === "paid") {
        return {
            success: false,
            message: "Link de cobrança já pago."
        }
    }
    charge.status = "paid"
    charge.logs.push({
        createdAt: new Date(),
        status: `Pagamento registrado com sucesso.`
    })
    const parameter = await getParameterByParkId({ estacionamentoId: charge.estacionamentoId })
    const pricesPayment = {
        dataPagamento: paymentDate,
        total: charge.total,
        formaPagamento: paymentMethod,
        f360SyncCoupon: randomNumber(),
        order: {
            tipo: `Online - PIX`,
        }
    }
    charge.cashier = {
        id: cashier?.id ?? "SEM_CAIXA_ABERTO",
        openAt: cashier?.openAt,
        openBy: cashier?.openBy
    }
    charge.payment = pricesPayment
    await changeCompanyTotals({ charge: charge })
    if (generateNote) {
        const newNote = await emitNoteIfNeed({ charge: charge })
        charge.newNote = newNote
    }
    await addF360Process({ charge: charge, parameter: parameter })
    charge.logs.push({
        createdAt: new Date(),
        status: "Pagamento registrado manualmente com sucesso."
    })
    await updateCompanyChargeById({ id: charge.id, data: charge })
    return {
        success: true,
        message: "Pagamento registrado com sucesso."
    }
}

const emitNoteIfNeed = async ({ charge }) => {
    if (charge.newNote?.document && charge.newNote?.currentStatus !== "NOTE_GENERATED") {
        const note = await getNewNoteByIdentifier({ identifier: charge.id })
        if (!note) {
            const user = getUsuarioCompact()
            var data = {
                revendaId: charge.revendaId,
                clienteId: charge.clienteId,
                estacionamentoId: charge.estacionamentoId,
                identifier: charge.id,
                noteType: "NFS-e",
                type: "company-charge",
                createdBy: user,
                createdAt: new Date(),
                status: [{
                    createdAt: new Date(),
                    status: "NOTE_PROCESSING",
                    createdBy: user
                }],
                currentStatus: "NOTE_PROCESSING",
                valor: charge.total,
                name: charge.newNote.name,
                document: normalizedField(charge.newNote.document)
            }
            return await addNewNote({ data: data })
        }
        return note
    }
    return null
}

const addF360Process = async ({ charge, parameter }) => {
    if (parameter.habilitarF360ERP) {
        const body = {
            ids: [charge.id],
            X_API_KEY: parameter.X_API_KEY,
            clienteId: parameter.clienteId,
            estacionamentoId: parameter.estacionamentoId,
            action: "PAYMENT",
            type: "COMPANY_CHARGE_PAYMENT"
        }
        const data = {
            revendaId: parameter.revendaId,
            clienteId: parameter.clienteId,
            estacionamentoId: parameter.estacionamentoId,
            origin: "F360 - LINK DE COBRABÇA",
            type: "F360",
            createdBy: getUsuarioCompact(),
            body: body
        }
        await addQueue({ data: data })
    }
}

const changeCompanyTotals = async ({ charge }) => {
    const company = await getCompanyById({ id: charge.companyId })
    if (charge.type === "partnership") {
        if (!company.logs) {
            company.logs = []
        }
        var partners = company.partners ?? []
        for (const partner of charge.partners) {
            var partnerFound = partners.find(e => e.id === partner.id)
            if (partnerFound) {
                var quantity = partnerFound.quantity
                if (isNaN(quantity)) {
                    quantity = 0
                }
                partnerFound.quantity = (quantity + partner.quantity)
            } else {
                partnerFound = partner
                partners.push(partner)
            }
            company.logs.push({
                id: generateUUIDV7(),
                createdBy: getUsuarioCompact(),
                createdAt: new Date(),
                message: `Adicionado ${partner.quantity} selos ao convênio ${partnerFound.name}, total: ${partnerFound.quantity}`,
                chargeId: charge.id
            })
        }
        company.partners = partners
        await updateCompanyById({ id: company.id, data: company })
    }
}